import React, { useState } from "react";


const dataList = [
  {
    title: "Head/Ears/Eyes/Nose/Throat",
    options: [
      "Headaches",
      "Migraines",
      "Head Injury",
      "Hyperthyroidism",
      "Hypothyroidism",
      "Glaucoma",
    ],
    name: "headEarsEyesNoseThroat",
  },
  {
    title: "Hematologic",
    options: [
      "Blood clots",
      "Delayed healing of wounds",
      "Peripheral Vascular Disease",
      "Increased bleeding",
      "Blockage of the blood vessels",
      "Heart Valve Disease",
    ],
    name: "hematologic",
  },
  {
    title: "Musculoskeletal/Rheumatologic",
    options: [
      "Aspirin",
      "Xarelto",
      "Plavix",
      "Coumadin",
      "Other",
      "Bursitis",
      "Osteoarthritis",
      "Chronic Joint Pains",
      "Osteoporosis",
      "Carpal Tunnel Syndrome",
      "Fibromyalgia",
      "Rheumatoid Arthritis",
    ],
    name: "musculoskeletalRheumatologic",
  },
  {
    title: "Cardiovascular",
    options: [
      "Anemia",
      "Heart Attack",
      "Coronary Artery Disease",
      "High Blood Pressure",
    ],
    name: "cardiovascular",
  },
  {
    title: "Respiratory",
    options: ["Asthma", "Bronchitis/Pneumonia", "Emphysema/COPD"],
    name: "respiratory",
  },
  {
    title: "Gastrointestinal",
    options: [
      "GERD (Acid Reflux)",
      "Gastritis",
      "Gastrointestinal Bleeding",
      "Stomach Ulcers",
      "Constipation",
    ],
    name: "gastrointestinal",
  },
  {
    title: "Neuropsychological",
    options: [
      "Anxiety",
      "Multiple Sclerosis",
      "Peripheral Neuropathy",
      "Seizures",
      "Schizophrenia",
      "Bipolar Disorder",
      "Depression",
    ],
    name: "neuropsychological",
  },
  {
    title: "Urological",
    options: [
      "Chronic Kidney Disease",
      "Kidney Stones",
      "Urinary Incontinence",
      "Dialysis",
    ],
    name: "urological",
  },
];

export const PastMedicalHistory = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [haveDisabilityForPain, setHaveDisabilityForPain] = useState("No");
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setPatientMedicationInfo({
      ...patientMedicationInfo,
      [name]: value,
    });
  };
  const [pastMedicationInfo, setPastMedicationInfo] = useState({
    medicationAllergies: "",
  });
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleOnChange2 = (e) => {
    const { name, value } = e.target;
    if (e.target.type === "checkbox") {
      const currentValue = patientMedicationInfo[name] || [];
      const currentArray = Array.isArray(currentValue) ? currentValue : [];
      const isChecked = currentArray.includes(value);
      
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: isChecked
          ? currentArray.filter((item) => item !== value)
          : [...currentArray, value],
      });
    } else {
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: value,
      });
    }
  };
  return (
    <div className="flex flex-col justify-between w-full gap-5 bg-white p-5 shadow-sm rounded">
      <div className="flex-1">
        <div className="my-5 flex flex-col gap-8 p-6 py-10 w-full  border-b border-[#d4d4d4]">
          <p className="font-mainFont font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] text-[#333333]">
            Have you ever been diagnosed with any chronic medical conditions
            such as diabetes, high blood pressure, Cancer, heart disease, or
            asthma?
          </p>
          <div className="flex justify-start items-center gap-4">
            <button
              onClick={() => {
                setHaveDisabilityForPain("Yes");
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  haveYouEveryDiagnosed: "Yes",
                });
              }}
              className={`text-[#333333] ${
                patientMedicationInfo.haveYouEveryDiagnosed === "Yes"
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
            >
              Yes
            </button>
            <button
              onClick={() => {
                setHaveDisabilityForPain("No");
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  haveYouEveryDiagnosed: "No",
                });
              }}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.haveYouEveryDiagnosed === "No"
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              No
            </button>
          </div>
        </div>
        
        <div className="my-5 flex flex-col gap-8 p-6 py-10 w-full  border-b border-[#d4d4d4]">
          <p className="font-mainFont font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] text-[#333333]">
            Have you ever been diagnosed with Dementia or Alzheimer's disease?
          </p>
          <div className="flex justify-start items-center gap-4">
            <button
              onClick={() => {
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  dementiaAlzheimers: "Yes",
                });
              }}
              className={`text-[#333333] ${
                patientMedicationInfo.dementiaAlzheimers === "Yes"
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
            >
              Yes
            </button>
            <button
              onClick={() => {
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  dementiaAlzheimers: "No",
                });
              }}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.dementiaAlzheimers === "No"
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              No
            </button>
          </div>
        </div>

        <div className="my-5 flex flex-col gap-8 p-6 py-10 w-full  border-b border-[#d4d4d4]">
          <p className="font-mainFont font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] text-[#333333]">
            Is there a chance that you are pregnant?
          </p>
          <div className="flex justify-start items-center gap-4">
            <button
              onClick={() => {
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  pregnant: "Yes",
                });
              }}
              className={`text-[#333333] ${
                patientMedicationInfo.pregnant === "Yes"
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
            >
              Yes
            </button>
            <button
              onClick={() => {
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  pregnant: "No",
                });
              }}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.pregnant === "No"
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              No
            </button>
          </div>
        </div>

        {patientMedicationInfo.haveYouEveryDiagnosed === "Yes" && (
          <>
            <div className="my-3">
              <h3 className="font-mainFont font-[600] text-[#fff] 2xl:text-[1.2vw] xl:text-[1.2vw] lg:text-[1.2vw] md:text-[2.3vw] text-[3.5vw]">
                General Medical
              </h3>
            </div>
            <div className="my-6 flex flex-col gap-6 2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[80%] w-[100%]">
              <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between items-center">
                <div className="flex w-full justify-start items-center gap-2">
                  <label htmlFor="cancer" className="text-[#333333]">
                    1. Cancer
                  </label>{" "}
                  {/* <input id="cancer" type="radio" /> */}
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                    placeholder="Enter cancer type"
                    onChange={handleOnChange}
                    name="cancerType"
                    value={patientMedicationInfo?.cancerType}
                  />
                </div>
              </div>

              <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between items-center">
                <div className="flex w-full justify-start items-center gap-2">
                  <label htmlFor="Diabetes" className="text-[#333333]">
                    2. Diabetes
                  </label>{" "}
                  {/* <input id="Diabetes" type="radio" /> */}
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                    placeholder="Enter diabetes type"
                    onChange={handleOnChange}
                    name="diabetesType"
                    value={patientMedicationInfo?.diabetesType}
                  />
                </div>
              </div>
              <div className="flex flex-col gap-6 2xl:px-8 xl:px-8 lg:px-8 md:px-8 px-2">
                <div className="flex justify-between items-center">
                  <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between w-full items-center gap-2">
                    <label htmlFor="Diabetes" className="text-[#333333] w-full">
                      A. Controlled?
                    </label>{" "}
                    <div className="flex justify-center items-center  2xl:w-[32%] xl:w-[32%] lg:w-[32%] md:w-[32%] w-[100%] pr-2 bg-white rounded-full">
                      <select
                        onChange={handleOnChange}
                        name="diabetesControlled"
                        value={patientMedicationInfo?.diabetesControlled}
                        className=" w-[95%] px-6 py-3 rounded-full border-none outline-none  font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor/60 bg-[#f0f0f0]"
                      >
                        <option className="text-mainColor/50">
                          -- Select --
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between items-center">
                  <div className="flex  justify-between w-full items-center gap-2">
                    <label htmlFor="Diabetes" className="text-[#333333]">
                      B. Blood Sugar Average weekly
                    </label>{" "}
                  </div>
                  <div className="w-full">
                    <input
                      type="text"
                      className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                      placeholder="weekly blood sugar level"
                      name="bloodSugarWeekly"
                      onChange={handleOnChange}
                      value={patientMedicationInfo?.bloodSugarWeekly}
                    />
                  </div>
                </div>

                <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between items-center">
                  <div className="flex w-full justify-start items-center gap-2">
                    <label htmlFor="Diabetes" className="text-[#333333]">
                      {" "}
                      C. Last Hb A1c
                    </label>{" "}
                  </div>
                  <div className="w-full">
                    <input
                      type="text"
                      className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                      placeholder="Enter last Hb Alc"
                      onChange={handleOnChange}
                      name="HBALC"
                      value={patientMedicationInfo?.HBALC}
                    />
                  </div>
                </div>
                <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-between items-center">
                  <div className="flex w-full justify-start items-center gap-2">
                    <label htmlFor="Diabetes" className="text-[#333333]">
                      {" "}
                      D. Any Diabetes related comorbidity
                    </label>{" "}
                  </div>
                  <div className="w-full">
                    <input
                      type="text"
                      className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                      placeholder="If,any comorbidity"
                      name="diabetesComorbidity"
                      onChange={handleOnChange}
                      value={patientMedicationInfo?.diabetesComorbidity}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="flex-1">
        <div className=" flex flex-col justify-start items-start gap-5  p-8  border-b border-[#d4d4d4] shadowsForMainWrappe w-full">
          <h3 className="font-mainFont font-[600] 2xl:text-[1.6vw] xl:text-[1.6vw] lg:text-[1.6vw] md:text-[2.3vw] text-[3.5vw] text-[#333333]">
            Do you have any drug/medication allergies?
          </h3>
          <div className="flex justify-start items-center gap-4">
            <button
              onClick={() => {
                setPastMedicationInfo({
                  ...pastMedicationInfo,
                  medicationAllergies: "Yes",
                });
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  medicationAllergies: "Yes",
                });
              }}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.medicationAllergies === "Yes"
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              Yes
            </button>
            <button
              onClick={() => {
                setPastMedicationInfo({
                  ...pastMedicationInfo,
                  medicationAllergies: "No",
                });
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  medicationAllergies: "No",
                  medicationAllergiesText: "", // Clear text when "No" is selected
                });
              }}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.medicationAllergies === "No"
                  ? "text-[#fff] BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              No
            </button>
          </div>
          
          {/* Text area - Show when "Yes" is selected */}
          {patientMedicationInfo.medicationAllergies === "Yes" && (
            <div className="mt-4 w-full">
              <textarea
                className="w-full border border-[#d4d4d4] bg-[#f0f0f0] px-5 py-3 rounded-lg outline-none 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-[400] font-mainFont text-[#333333] placeholder:text-[#333333] resize-y min-h-[100px]"
                placeholder="Please specify your drug/medication allergies..."
                value={patientMedicationInfo.medicationAllergiesText || ""}
                onChange={(e) => {
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    medicationAllergiesText: e.target.value,
                  });
                }}
                rows={4}
              />
            </div>
          )}
        </div>

        <div className="2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[80%] w-[100%] flex flex-col gap-5 mt-10">
          {dataList.map((list, id) => (
            <AccordionItem
              key={id}
              index={id}
              title={list.title}
              checkList={list.options}
              isOpen={openIndex === id}
              onToggle={handleToggle}
              name={list.name}
              handleOnChange={handleOnChange2}
              patientMedicationInfo={patientMedicationInfo}
            />
          ))}
        </div>
      </div>
    </div>
  );
};



const AccordionItem = ({
  title,
  checkList,
  isOpen,
  index,
  onToggle,
  name,
  handleOnChange,
  patientMedicationInfo
}) => {
  return (
    <>
      <div className="bg-transparent">
        <button
          style={{
            background: isOpen ? "#24518B" : "transparent",
            color: isOpen ? "#fff" : "#0C0544",
          }}
          className={`flex flex-col justify-start items-start w-full gap-4 py-4 border-b border-[#d4d4d4] ${
            isOpen ? "px-8 rounded-full border-b-0" : "px-4 rounded-none "
          } text-left  focus:outline-none  transition-all duration-300 ease-linear`}
          onClick={() => onToggle(index)}
        >
          <div className="flex justify-between items-center w-full">
            <span
              className={`font-[700] font-mainFont 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.5vw] ${
                isOpen ? "text-[#fff]" : "text-[#333333]"
              }`}
            >
              {title}
            </span>

            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`w-5 h-5 transition-transform duration-500 ${
                isOpen ? "transform rotate-180" : ""
              }`}
            >
              <path
                d="M13.9999 3.33326L1.99994 3.33326C1.87845 3.33364 1.75936 3.36715 1.65549 3.43018C1.55163 3.49321 1.46692 3.58337 1.41048 3.69097C1.35404 3.79856 1.32802 3.9195 1.33521 4.04079C1.3424 4.16207 1.38253 4.27909 1.45128 4.37926L7.45128 13.0459C7.69994 13.4053 8.29861 13.4053 8.54794 13.0459L14.5479 4.37926C14.6174 4.2793 14.6581 4.16222 14.6657 4.04073C14.6733 3.91925 14.6474 3.79801 14.5909 3.69019C14.5344 3.58237 14.4495 3.49209 14.3453 3.42917C14.2411 3.36624 14.1217 3.33307 13.9999 3.33326Z"
                fill={isOpen ? "white" : "#0A1E44"}
              />
            </svg>
          </div>
        </button>
        <div
          className={`overflow-hidden transition-all duration-500 ease-linear ${
            isOpen ? "max-h-96" : "max-h-0"
          }`}
        >
          <div className="p-6 bg-transparent flex flex-col gap-4">
            {checkList.map((cur, id) => (
              <>
                <div className="flex justify-start items-center gap-3">
                  <input
                    name={name}
                    type="checkbox"
                    id={`section${index + 1}_${id}`}
                    value={cur}
                    onChange={handleOnChange}
                    checked={Array.isArray(patientMedicationInfo[name]) 
                      ? patientMedicationInfo[name].includes(cur) 
                      : false}
                  />
                  <label
                    htmlFor={`section${index + 1}_${id}`}
                    className="font-mainFont font-[400] text-[#333333] 2xl:text-[1.2vw] xl:text-[1.2vw] lg:text-[1.2vw] md:text-[2.3vw] text-[3.5vw]"
                  >
                    {cur}
                  </label>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
